const title = {
	es: {
		first: "Gracias ",
		last: "por compartir tu información."
	},
	en: {
		first: "Thank you ",
		last: "for sharing your info."
	},
	pt: {
		first: "Agradecemos ",
		last: "por compartilhar suas informações."
	}
}

const content = {
	es: '¿Quieres seguir leyendo? Vuelve a inicio para aprender más sobre nosotros y cómo impulsaremos tu negocio al éxito.',
	en: 'Want to keep reading? Head back to the homepage to learn more about who we are and how we’ll fast-track your business to success.',
	pt: 'Quer continuar lendo? Volte para a página inicial e descubra mais sobre quem somos e como podemos ajudar sua empresa a chegar mais longe.',
}

export { title, content };